import reduce from "lodash/reduce";
import map from "lodash/map";
import fromPairs from "lodash/fromPairs";
import omit from "lodash/omit";
import includes from "lodash/includes";

import getIsSimulatedSource from "selectors/story/getIsSimulatedSource";
import reduxStore from "utils/storeFactory";
import { titleize, underscored } from "underscore.string";

export default function send(data, options) {
  const keysToCapitalizeValues = [
    "clickTarget",
    "interactionType",
    "item",
    "mediaType",
  ];

  const keysToChange = {
    time: "playbackTime",
  };

  let parsedData = reduce(
    data,
    (memo, value, key) => ({
      ...memo,
      [key]: includes(keysToCapitalizeValues, key) ? titleize(value) : value,
    }),
    {},
  );
  parsedData = reduce(
    parsedData,
    (memo, value, key) => {
      if (keysToChange[key]) {
        return {
          ...memo,
          [keysToChange[key]]: value,
        };
      }

      return {
        ...memo,
        [key]: value,
      };
    },
    {},
  );
  parsedData = map(parsedData, (value, key) => [underscored(key), value]);
  parsedData = fromPairs(parsedData);
  parsedData = omit(parsedData, "timestamp");

  const playerOptions = reduxStore.getState().playerOptions;
  const enableAnalytics =
    Boolean(playerOptions.enableAnalytics) && !playerOptions.designMode;
  const doNotTrack = navigator.doNotTrack === "1";

  if (document.hidden) {
    return;
  }

  if (!getIsSimulatedSource() && enableAnalytics && !doNotTrack) {
    const onlySendLocally = options && options.onlySendLocally;

    if (
      !onlySendLocally &&
      typeof window !== "undefined" &&
      typeof window.analytics !== "undefined"
    ) {
      try {
        window.analytics.track(parsedData.event, parsedData, { verbose: 1 });
      } catch (error) {
        //eslint-disable-next-line no-console
        console.error("Segment.io error captured in player", error);
      }
    }
  }

  try {
    const verseStore = reduxStore.getState();

    const debugAnalytics = verseStore.playerOptions.debugAnalytics;
    const debugAnalyticsWithStringifiedWarnings =
      verseStore.playerOptions.debugAnalyticsWithStringifiedWarnings;

    /*eslint-disable no-console*/
    if (console) {
      if (debugAnalyticsWithStringifiedWarnings) {
        console.warn(
          JSON.stringify({
            ...omit(parsedData, "event"),
            event: parsedData.event,
            analyticsDebugging: true,
          }),
        );
      } else if (debugAnalytics) {
        console.log(parsedData.event, omit(parsedData, "event"));
      }
    }
    /*eslint-enable no-console*/
  } catch {}
}
